import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useReservationAdminAPI } from "../../service/useReservationAdminAPI";
import Loading from "../common/Loading";
import AppSnackbar from "../../common/AppSnackbar";
import "@event-calendar/core/index.css";
import BookingCalendar from "./BookingCalendar";
import { startOfMonth } from "date-fns";
import { useTranslation } from "react-i18next";

const MyReservations = () => {
  const { t } = useTranslation();
  const { getAllReservationPeriodsForMonthAndYear, getAllStayResources } =
    useReservationAdminAPI();
  const [stayResources, setStayResources] = useState([]);
  const [reservationPeriods, setReservationPeriods] = useState([]);

  const [startDate, setStartDate] = useState(startOfMonth(new Date()));
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  function handleFetchError(reason) {
    setSnackbarMessage(reason);
    setOpenSnackbar(true);
  }

  useEffect(() => {
    handleRefreshScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate]);

  const handleRefreshScreen = () => {
    getAllStayResources()
      .then((stayResources) => {
        setStayResources(stayResources);
        getAllReservationPeriodsForMonthAndYear(
          startDate.getMonth() + 1,
          startDate.getFullYear(),
        ).then((value) => setReservationPeriods(value));
      })
      .catch(() => handleFetchError(t("reservationManagementFetchFailed")));
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}
      >
        <Grid item xs={12} sm={12} sx={{ p: 2, m: 2 }} data-testid="reservation-management-container">
          <BookingCalendar
            stayResources={stayResources}
            reservationPeriods={reservationPeriods}
            startDate={startDate}
            setStartDate={setStartDate}
          />
          <AppSnackbar
            openSnackbar={openSnackbar}
            snackbarMessage={snackbarMessage}
            setOpenSnackbar={setOpenSnackbar}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default withAuthenticationRequired(MyReservations, {
  onRedirecting: () => <Loading />,
  returnTo: "/beheer/login",
});
